import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Clock, Calendar, Users } from "lucide-react";

const ClassesSection = () => {
  const schedule = [
    {
      day: "Monday - Friday",
      classes: [
        { time: "5:00 PM - 6:00 PM", type: "Teens Class", level: "All Levels" },
        { time: "6:00 PM - 7:00 PM", type: "Competition Class", level: "All Levels" },
        { time: "7:00 PM - 8:00 PM", type: "Kids Class", level: "All Levels" },
        { time: "8:00 PM - 9:00 PM", type: "Adults Class", level: "All Levels" }
      ]
    },
    {
      day: "Saturday",
      classes: [
        {
          time: "Open on select Saturdays for classes, sparring, or open gym. Dates announced in advance."
        }
      ]
    }
  ];

  return (
    <section id="classes" className="py-20 bg-red-600">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Classes & 
            <span className="text-black"><i> Schedule </i></span>
          </h2>
          <p className="text-gray-300 text-xl">
            Structured training sessions designed for every skill level
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          {schedule.map((daySchedule, index) => (
            <Card key={index} className="bg-black border-red-white mb-8">
              <CardHeader>
                <CardTitle className="text-2xl font-bold text-red-600 flex items-center">
                  <Calendar className="mr-3" size={24} />
                  {daySchedule.day}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="space-y-4">
                  {daySchedule.classes.map((classItem, classIndex) => (
                    <div
                      key={classIndex}
                      className="flex flex-col md:flex-row md:items-center justify-between p-4 bg-red-600 rounded-lg border border-white"
                    >
                      {daySchedule.day === "Saturday" ? (
                        // Saturday: only text, no icons
                        <span className="text-white font-semibold text-lg">
                          {classItem.time}
                        </span>
                      ) : (
                        // Other days: show full icons and structure
                        <>
                          <div className="flex items-center mb-2 md:mb-0">
                            <Clock className="text-black mr-3" size={20} />
                            <span className="text-white font-semibold text-lg">
                              {classItem.time}
                            </span>
                          </div>

                          <div className="flex flex-col md:flex-row md:items-center gap-4">
                            <div className="text-white font-medium">
                              {classItem.type}
                            </div>
                            <div className="flex items-center">
                              <Users className="text-white mr-2" size={16} />
                              <span className="text-black text-sm">
                                {classItem.level}
                              </span>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="mt-12 text-center bg-black text-white p-6 rounded-lg max-w-2xl mx-auto">
          <h3 className="text-xl font-bold mb-2">Important Notice</h3>
          <p className="text-red-100">
            Times may change—check Instagram or call for weekly updates.
          </p>
          <p className="text-red-100 mt-2">
            Follow us @claraboxingacademy for the latest schedule updates.
          </p>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-8 text-center">
          <div className="bg-black p-6 rounded-lg border border-red-600/20">
            <div className="text-red-600 text-3xl mb-4">👥</div>
            <h4 className="text-white font-bold text-lg mb-2">Small Classes</h4>
            <p className="text-gray-300">Personal attention for every member</p>
          </div>

          <div className="bg-black p-6 rounded-lg border border-red-600/20">
            <div className="text-red-600 text-3xl mb-4">🏆</div>
            <h4 className="text-white font-bold text-lg mb-2">Competition Prep</h4>
            <p className="text-gray-300">Train like a champion if you choose</p>
          </div>

          <div className="bg-black p-6 rounded-lg border border-red-600/20">
            <div className="text-red-600 text-3xl mb-4">📈</div>
            <h4 className="text-white font-bold text-lg mb-2">Progress Tracking</h4>
            <p className="text-gray-300">See your improvement week by week</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClassesSection;
